import AsyncStorage from '@react-native-async-storage/async-storage';
import {create} from 'zustand';
import {persist, createJSONStorage} from 'zustand/middleware';

interface CatalogState {
  catalogData: IProduct[] | null;
  setCatalogData: (catalogData: IProduct[]) => void;
  clearCatalog: () => void;
}

export const useCatalogStore = create(
  persist<CatalogState>(
    set => ({
      catalogData: null,

  setCatalogData: (catalogData: IProduct[]) => set(() => ({catalogData})),

      clearCatalog: () =>
        set(() => ({
          catalogData: null,
        })),
    }),
    {
      name: 'catalog_store',
      storage: createJSONStorage(() => AsyncStorage),
    },
  ),
);
